<template>
  <v-row>
    <v-dialog v-model="showDialog" scrollable max-width="900px">
      <v-card>
        <v-card-title>
          <v-panel>
            <span style="font-size: 20px;">
              {{ $t("wkt.admin.training-notification.window.title") }}
            </span>
          </v-panel>
        </v-card-title>
        <v-card-text @wheel="onWheel">
          <v-container>
            <v-form ref="form">
              <v-row>
                <v-col cols="12">
                  <v-autocomplete
                    v-model="enrollmentIds"
                    :items="enrollments"
                    :item-text="getEnrollmentText"
                    item-value="id"
                    :label="$t('wkt.admin.training-notification.window.enrollments')"
                    multiple
                    chips
                    deletable-chips
                    :disabled="isReadOnly"
                    :menu-props="trainingNotificationDialogMenuProps"
                    clearable
                    :rules="[validationRules.required]"
                  />
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12">
                  <v-text-field
                    v-model="title"
                    :label="$t('wkt.admin.training-notification.window.subject')"
                    :rules="[validationRules.required]"
                    maxlength="200"
                    counter="200"
                    :disabled="isReadOnly"
                  />
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12">
                  <v-textarea
                    v-model="body"
                    :label="$t('wkt.admin.training-notification.window.body')"
                    :rules="[validationRules.required]"
                    auto-grow
                    rows="4"
                    maxlength="2000"
                    counter="2000"
                    :disabled="isReadOnly"
                  />
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12">
                  <span style="color: #757575; font-size: 13px;">
                    {{ $t("wkt.admin.training-notification.window.note") }}
                  </span>
                </v-col>
              </v-row>
            </v-form>
          </v-container>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="#185EA9"
            text
            @click="onSave()"
            style="font-size: 0.9em; font-weight: 400;"
            :disabled="isReadOnly"
          >
            {{ $t("wkt.admin.common.dialog-buttons.ok").toUpperCase() }}
          </v-btn>
          <v-btn
            text
            @click="showDialog = false"
            style="font-size: 0.9em; font-weight: 400;"
          >
            {{ $t("wkt.admin.common.dialog-buttons.cancel").toUpperCase() }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import BaseModule from "../../common/BaseModule.js";

export default {
  name: "TrainingNotificationDialog",
  mixins: [BaseModule],
  data() {
    return {
      showDialog: false,
      isReadOnly: false,
      trainingAction: null,
      enrollments: [],
      trainingNotificationDialogMenuProps: {
        zIndex: 260,
        contentClass: "training-notification-dialog-menu",
      },
      enrollmentIds: [],
      title: "",
      body: "",
    };
  },
  mounted() {
    this.installShadowMenuWheelPatch({
      menuSelector: ".training-notification-dialog-menu",
      handlerKey: "__tweemTrainingNotificationManualWheelHandler",
    });
  },
  beforeDestroy() {
    this.teardownShadowMenuWheelPatch();
  },
  methods: {
    onWheel(event) {
      if (!event) {
        return;
      }

      event.stopPropagation();
    },
    open(payload) {
      this.showDialog = true;
      this.isReadOnly = !!payload?.isReadOnly;
      this.trainingAction = payload?.trainingAction || null;
      this.enrollments = payload?.enrollments || [];
      this.enrollmentIds = [];
      this.title = "";
      this.body = "";

      if (this.$refs.form) {
        this.$refs.form.resetValidation();
      }
    },
    getEnrollmentText(item) {
      if (!item) {
        return "";
      }
      const fullName = `${item.employeeLastname || ""}, ${item.employeeFirstname || ""}`.replace(/^,\s*/, "");
      const context = [item.employeeDepartmentName, item.employeeWorkplaceName].filter(Boolean).join(" - ");
      return context ? `${fullName} - ${context}` : fullName;
    },
    onSave() {
      if (!this.$refs.form.validate()) {
        return;
      }

      this.$emit("save", {
        trainingActionId: this.trainingAction?.id || null,
        enrollmentIds: this.enrollmentIds,
        title: this.title,
        body: this.body,
      });
      this.showDialog = false;
    },
  },
};
</script>
